import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormNote } from '../../../components/common/form'
import {
  MissionSummaryCard,
  ProjectSummaryCard,
} from '../../../components/quickCreate/ParentSummaryCard'
import { useMissionBudget, useProjectBudget } from '../../../components/quickCreate/parentInfo'
import ContextFields from './ContextFields'
import { ImportContext } from './importRowModel'

type ContextStepProps = {
  value: ImportContext
  onChange: (next: ImportContext) => void
  onLabels: (labels: Record<string, string>) => void
  rowCount?: number
  lockMission?: boolean
  lockProject?: boolean
}

export default function ContextStep({
  value,
  onChange,
  onLabels,
  rowCount,
  lockMission,
  lockProject,
}: ContextStepProps) {
  const { t } = useTranslation()
  const mission = useMissionBudget(value.MissionId || undefined)
  const project = useProjectBudget(value.ProjetId || undefined)

  return (
    <div className="action-import-context">
      <FormNote>
        {rowCount
          ? t('actionImport.context.introWithCount', { count: rowCount })
          : t('actionImport.context.intro')}
      </FormNote>
      <ContextFields
        value={value}
        onChange={onChange}
        onLabels={onLabels}
        lockMission={lockMission}
        lockProject={lockProject}
        missionSlot={<MissionSummaryCard info={mission.data} status={mission.status} />}
        projectSlot={<ProjectSummaryCard info={project.data} status={project.status} />}
      />
    </div>
  )
}
